"use strict";
// 启动服务相关工具函数与纯函数逻辑模块（基于 PM2 Node.js API）
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServerPaths = getServerPaths;
exports.checkServerOnline = checkServerOnline;
exports.startAgentServerWithPM2 = startAgentServerWithPM2;
exports.getServerStatus = getServerStatus;
exports.removeAgentServerWithPM2 = removeAgentServerWithPM2;
const path = __importStar(require("path"));
const fs = __importStar(require("fs"));
const pm2_1 = __importDefault(require("pm2"));
const cli_core_1 = require("@/cli-core");
/**
 * 获取产物目录路径
 * @returns 包含 serverPath 和 serverDir 的对象
 */
function getServerPaths() {
    let res = {
        serverPath: path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'server/main.js'),
        serverDir: path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'server'),
    };
    return res;
}
/**
 * 检查 Agent Server 是否在 PM2 中处于 online 状态
 * @param serverName 服务名称
 * @returns 是否在线的布尔值
 */
function checkServerOnline(serverName) {
    return new Promise(resolve => {
        pm2_1.default.connect(err => {
            if (err) {
                resolve(false);
                return;
            }
            const pm2Any = pm2_1.default;
            pm2Any.describe(serverName, (err, list) => {
                pm2_1.default.disconnect();
                if (err || !list || list.length === 0) {
                    resolve(false);
                    return;
                }
                const target = list[0];
                resolve(Boolean(target && target.pm2_env && target.pm2_env.status === 'online'));
            });
        });
    });
}
/**
 * 启动Agent Server基于PM2
 * @param port 端口号
 * @param serverName 服务名称
 * @returns 启动是否成功
 */
function startAgentServerWithPM2(port, serverName) {
    const { serverPath, serverDir } = getServerPaths();
    if (!fs.existsSync(serverPath)) {
        cli_core_1.CLI.loading.fail(`找不到 Agent Server 入口文件: ${serverPath}`);
        return Promise.resolve(false);
    }
    cli_core_1.CLI.loading.start(`正在通过 PM2 启动 ${serverName} (端口: ${port})...`);
    return new Promise(resolve => {
        pm2_1.default.connect(err => {
            if (err) {
                cli_core_1.CLI.loading.fail(`PM2 连接失败: ${err.message}`);
                resolve(false);
                return;
            }
            const pm2Any = pm2_1.default;
            pm2Any.describe(serverName, (err, list) => {
                const isExist = !err && list && list.length > 0;
                const pm2Output = path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'server', '/server-out.log');
                const pm2Error = path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'server', '/server-err.log');
                const options = {
                    script: serverPath,
                    name: serverName,
                    cwd: serverDir,
                    env: {
                        ...process.env,
                        PORT: port,
                        NODE_ENV: 'production',
                    },
                    output: pm2Output,
                    error: pm2Error,
                    autorestart: true,
                };
                const handleResult = (actionErr) => {
                    pm2_1.default.disconnect();
                    if (actionErr) {
                        cli_core_1.CLI.loading.fail(`PM2 服务操作失败: ${actionErr.message}`);
                        resolve(false);
                        return;
                    }
                    cli_core_1.CLI.loading.succeed(`${serverName} 已成功通过PM2在后台运行`);
                    resolve(true);
                };
                if (isExist) {
                    // 已存在则重启并更新环境变量
                    pm2Any.restart(serverName, options, handleResult);
                }
                else {
                    // 不存在则新建并常驻后台
                    pm2Any.start(options, handleResult);
                }
            });
        });
    });
}
/**
 * 获取服务状态
 * @param serverName 服务名称
 */
function getServerStatus(serverName) {
    return new Promise(resolve => {
        pm2_1.default.connect(err => {
            if (err) {
                resolve({ exists: false, online: false });
                return;
            }
            const pm2Any = pm2_1.default;
            pm2Any.describe(serverName, (err, list) => {
                pm2_1.default.disconnect();
                if (err || !list || list.length === 0) {
                    resolve({ exists: false, online: false });
                    return;
                }
                const target = list[0];
                resolve({
                    exists: true,
                    online: Boolean(target && target.pm2_env && target.pm2_env.status === 'online'),
                });
            });
        });
    });
}
/**
 * 从 PM2 中卸载指定服务
 * @param serverName 服务名称
 */
function removeAgentServerWithPM2(serverName) {
    return new Promise(resolve => {
        pm2_1.default.connect(err => {
            if (err) {
                resolve(false);
                return;
            }
            const pm2Any = pm2_1.default;
            pm2Any.delete(serverName, (err) => {
                pm2_1.default.disconnect();
                if (err) {
                    resolve(false);
                    return;
                }
                pm2Any.save?.(() => { });
                resolve(true);
            });
        });
    });
}
